import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    colorToken,
    colorTokenArgs,
    designContext,
    interactiveState,
    disabled,
    isBig,
    isSmall
  } = _ref;
  var iconSize = isBig ? 30 : 20; // isSmall (default)

  var clickableRadius = isSmall ? 0 : 6;
  var iconClickableSize = isSmall ? iconSize : iconSize + clickableRadius * 2;
  var borderRadius = designContext.get('touchable-icon/corner-radius').pixelValue;
  return {
    containerStyle: {
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: 'none',
      cursor: disabled ? 'default' : 'pointer',
      display: 'block',
      padding: 0,
      position: 'relative',
      outline: 0,
      overflow: 'visible',
      height: iconSize,
      width: iconSize
    },
    focusedBorderStyle: {
      position: 'absolute',
      borderColor: colorToken ? designContext.get(colorToken, colorTokenArgs).toString() : designContext.get('touchable-icon/color').toString(),
      borderRadius,
      borderStyle: 'solid',
      borderWidth: 2,
      height: iconClickableSize,
      width: iconClickableSize
    },
    overlayStyle: {
      height: iconClickableSize,
      width: iconClickableSize,
      margin: 0 - clickableRadius
    },
    iconWrapperStyle: {
      height: iconSize,
      margin: clickableRadius,
      width: iconSize
    },
    iconColorToken: colorToken ? colorToken : 'touchable-icon/color',
    iconColorTokenArgs: _objectSpread({
      interactiveState
    }, colorToken ? colorTokenArgs : {})
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map